(function ($) {
    'use strict';

    var Page = (function () {
        var initVegasAnimation = function () {

            var indexTexilate = 0,
                    walk = 0;
            var indexTexilateCount = $('.texts li').length;

            if (typeof vegasSlides !== 'undefined') {
                $(".vegas-piktogram").slick({ 
                    speed: 1000,
                    fade: true, 
                    dots: false,
                    prevArrow: false,
                    nextArrow: false,
                    cssEase: 'linear'
                });

                $(".vegas-body-main").vegas({
                    slides: vegasSlides,
                    animation: ['kenburns'],
                    delay: 9000,
                    walk: function (index, slideSettings) {
                         console.log(indexTexilate+" = "+indexTexilateCount);
                        $('.vegas-text').textillate('in', indexTexilate);

                        if (indexTexilate == indexTexilateCount-1) {
                            indexTexilate = 0;
                        } else {
                            indexTexilate++;
                        }
//                        console.log(walk);
//                        if (walk > 0) {
                            $(".vegas-piktogram").slick("slickNext");
//                        }
//                        walk++;
                    }
                });

                $(".vegas-body-second").vegas({
                    slides: vegasSlides,
                    animation: ['kenburns'],
                    delay: 7000,
                });

                $('.vegas-text').textillate({
                    autoStart: false,
                    loop: true,
                    in: {
                        effect: "fadeIn",
                        reverse: false,
                        shuffle: false,
                        sync: true,
                        loop: true,
                    },
                    out: {
                        effect: "fadeOut",
                        reverse: false,
                        shuffle: false,
                        sync: true,
                    }
                });
            }
        };
        var initVegasHeight = function () {
            var myWidth = 0,
                    myHeight = 0;
            if (typeof (window.innerWidth) == 'number') {
                //Non-IE
                myWidth = window.innerWidth;
                myHeight = window.innerHeight;
            } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
                //IE 6+ in 'standards compliant mode'
                myWidth = document.documentElement.clientWidth;
                myHeight = document.documentElement.clientHeight;
            } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
                //IE 4 compatible
                myWidth = document.body.clientWidth;
                myHeight = document.body.clientHeight;
            }
            var vegasH = myHeight - $('.navbar').height() - (myHeight * 0.1);
            $('.vegas-body-main').css('min-height', vegasH);

            $('.vegas-body-second').css('min-height', vegasH * 0.6);

            console.log('Width = ' + myWidth);
            console.log('Height = ' + myHeight);
            console.log($('.navbar').height());
            console.log('Height vegas = ' + vegasH);
        }
        var initOwlCarousel = function () {

            $(".owl-clients1").owlCarousel({
                items: 6,
                dots: false,
                loop: true,
                autoplay: true,
                autoPlaySpeed: 3000,
                autoPlayTimeout: 4000,
                // autoplayHoverPause: true,
                itemsDesktop: [1000, 5],
                itemsDesktopSmall: [900, 4],
                itemsTablet: [600, 3],
                itemsMobile: [300, 2],
                margin: 10,
                autoWidth: true,
            });
            $(".owl-clients2").owlCarousel({
                items: 6,
                dots: false,
                loop: true,
                autoplay: true,
                autoPlaySpeed: 6000,
                autoPlayTimeout: 1000,
                // autoplayHoverPause: true,
                itemsDesktop: [1000, 5],
                itemsDesktopSmall: [900, 4],
                itemsTablet: [600, 3],
                itemsMobile: [300, 2],
                margin: 10,
                autoWidth: true,
            });

        }
        var initSlickCarousel = function () {

            $(".owl-clients1").slick({
                dots: false,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 5000,
                slidesToShow: 4,
                slidesToScroll: 4,
                autoplay: true,
                responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $(".owl-clients2").slick({
                dots: false,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 6000,
                slidesToShow: 4,
                slidesToScroll: 4,
                autoplay: true,
                responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
        return {
            init: function () {
                initVegasHeight();
                initSlickCarousel();
                initVegasAnimation();
                //  initOwlCarousel();
            }
        }
    })();
    var PageContactForm = function () {

        return {

            //Contact Form
            initPageContactForm: function () {
                // Validation
                $("#contact-form").validate({
                    // Rules for form validation
                    rules: {
                        name: {
                            required: true
                        },
                        company: {
                            required: true
                        },
                        phone: {
                            required: true
                        },
                        city: {
                            required: true
                        },
                        message: {
                            required: true,
                            minlength: 10
                        },
                        email: {
                            required: true,
                            email: true
                        }
                    },

                    // Messages for form validation
                    messages: {
                        name: {
                            required: 'Proszę uzupełnić pole',
                        },
                        company: {
                            required: 'Proszę uzupełnić pole',
                        },
                        phone: {
                            required: 'Proszę uzupełnić pole',
                        },
                        city: {
                            required: 'Proszę uzupełnić pole',
                        },
                        email: {
                            required: 'Proszę uzupełnić pole',
                            email: 'Niepoprawny adres e-mail'
                        },
                        message: {
                            required: 'Proszę uzupełnić pole',
                            minlength: 'Proszę wprowadzić minimum 10 znaków'
                        }
                    },

                    // Ajax form submition
                    submitHandler: function (form) {
                        //$('#contact-form button[type="submit"]').attr('disabled', true);
                        $("#contact-form").ajaxSubmit({
                            beforeSend: function () {
                                $('#contact-form button[type="submit"]').attr('disabled', true);
                            },
                            success: function (responseText, statusText, xhr, $form) {
                                if (statusText == "success")
                                    $("#contact-form").addClass('submited');
                            }
                        });
                    },

                    // Do not change code below
                    errorPlacement: function (error, element) {
                        error.insertAfter(element.parent());
                    }
                });
            }

        };

    }();

    $(document).ready(function () {
        var menuHeight = $('.menu-main-top ').height();

        window.moveScreenTo = function (e, element) {
            $('html,body').animate({
                scrollTop: $(element).offset().top - menuHeight
            }, 3000);
            return false;
        }


        if (jQuery(window).scrollTop() > 100) {
            jQuery('.header-fixed .header-sticky').addClass('header-fixed-shrink');
        }
        jQuery(window).scroll(function () {
            if (jQuery(window).scrollTop() > 100) {
                jQuery('.header-fixed .header-sticky').addClass('header-fixed-shrink');
            } else {
                jQuery('.header-fixed .header-sticky').removeClass('header-fixed-shrink');
            }

            if ($('.counter-container').length > 0) {
                var div_top = $('.counter-container').offset().top - 600;
                if ($(window).scrollTop() > div_top) {
                    $('.count').each(function () {
                        if (!$(this).hasClass("counted")) {
                            $(this).addClass("counted");
                            $(this).prop('Counter', 0).animate({
                                Counter: $(this).text()
                            }, {
                                duration: 4000,
                                easing: 'swing',
                                step: function (now) {
                                    $(this).text(Math.ceil(now));
                                }
                            });
                        }
                    });
                }
            }
        });


        PageContactForm.initPageContactForm();
        Page.init();
    });

})(jQuery);
